import { SettingsIcon } from "@chakra-ui/icons";
import { Box, Button, Flex, Grid, Stack, Text } from "@chakra-ui/react";
import { PipelineListItem } from "./types";

export const PipelineListCard = ({
  pipeline,
  onEdit,
  onDelete
}: {
  pipeline: PipelineListItem;
  onEdit: () => void;
  onDelete: () => void;
}) => {
  const statusLabel = pipeline.finished ? "Finalizado" : "Em Andamento";
  const statusColor = pipeline.finished ? "#177C58" : "#DC8B00";
  const statusBackground = pipeline.finished ? "#D9F6EA" : "#F4E8CE";

  const endState = pipeline.states.find((s) => s.operation === "END");
  const endStateId = endState?.id;
  const event200 =
    endStateId != null && pipeline.statusByState
      ? pipeline.statusByState.states?.[String(endStateId)]?.events?.find(
          (e) => e.code === 200
        )
      : undefined;
  const finalizados = event200?.total ?? null;

  return (
    <Box
      pos="relative"
      bg="#F3F4F6"
      border="1px solid #CBD5E0"
      borderRadius="10px"
      p="14px"
      boxShadow="0 2px 8px rgba(15, 23, 42, 0.08)"
      overflow="hidden"
      _before={{
        content: '""',
        pos: "absolute",
        left: 0,
        top: 0,
        bottom: 0,
        w: "4px",
        bg: "var(--chakra-colors-primary-400)"
      }}
    >
      <Flex justify="space-between" align="start" gap="12px">
        <Stack spacing="2px">
          <Text
            fontSize="21px"
            fontWeight="700"
            lineHeight="26px"
            color="#1A202C"
          >
            {`Pipeline ${pipeline.id}`}
          </Text>
          <Text
            fontSize="13px"
            lineHeight="16px"
            color="#8A94A6"
            fontWeight="500"
          >
            Mailing: {pipeline.mailingName}
          </Text>
        </Stack>

        <Box
          px="10px"
          py="4px"
          borderRadius="999px"
          bg={statusBackground}
          color={statusColor}
          fontWeight="600"
          fontSize="12px"
          lineHeight="15px"
          textTransform="lowercase"
        >
          {statusLabel}
        </Box>
      </Flex>

      <Grid mt="12px" templateColumns="1fr 1fr 1fr" gap="12px">
        <Box
          // bg="#E8EBF0"
          borderRadius="12px"
          py="8px"
          px="6px"
          textAlign="center"
        >
          <Text
            color="#2D77CF"
            fontWeight="700"
            fontSize="24px"
            lineHeight="29px"
          >
            {pipeline.states.length}
          </Text>
          <Text
            color="#5E687A"
            fontWeight="500"
            fontSize="14px"
            lineHeight="17px"
          >
            Blocos
          </Text>
        </Box>

        <Box
          // bg="#E8EBF0"
          borderRadius="12px"
          py="8px"
          px="6px"
          textAlign="center"
        >
          <Text
            color="#5E687A"
            fontWeight="500"
            fontSize="14px"
            lineHeight="17px"
          >
            Criado em:
          </Text>
          <Text
            color="#73809B"
            fontWeight="700"
            lineHeight="29px"
            fontSize="14px"
          >
            {pipeline.createDate
              ? new Date(pipeline.createDate).toLocaleDateString("pt-BR")
              : "-"}
          </Text>
        </Box>

        <Box
          // bg="#E8EBF0"
          borderRadius="12px"
          py="8px"
          px="6px"
          textAlign="center"
        >
          <Text
            color="#177C58"
            fontWeight="700"
            fontSize="24px"
            lineHeight="29px"
          >
            {finalizados ?? "-"}
          </Text>
          <Text
            color="#5E687A"
            fontWeight="500"
            fontSize="14px"
            lineHeight="17px"
          >
            Finalizados
          </Text>
        </Box>
      </Grid>

      <Flex mt="12px" gap="8px" align="center">
        <Button
          flex="1"
          bgGradient="linear(to-r, #061A48, #0A173E)"
          color="white"
          leftIcon={<SettingsIcon />}
          _hover={{ opacity: 0.95 }}
          _active={{ opacity: 0.9 }}
          onClick={onEdit}
          lineHeight="19px"
          fontWeight="700"
        >
          Visualizar Pipeline
        </Button>
      </Flex>
    </Box>
  );
};
